import {
  CANCEL_TRIP_HEADER,
  CHECK_REFUND_HEADER,
  EMAIL_TRIP_HEADER,
  CHANGE_FLIGHT_HEADER
} from 'AccountsConstants/language/trips'
import {
  AIR_TRIP,
  TRAIN_TRIP,
  HOTEL_TRIP,
  LOCAL_TRIP
} from 'AccountsConstants/app'
import { isCancellable, isAmendable } from 'AccountsUtils/validator'
import { objectHasKey, htmlDecoder } from 'AccountsUtils/common'
import { getCookie } from 'AccountsUtils'

export * from './TripDetails'

export const populateTripResponse = (data, key) => {
  let returnVal = []
  if (
    data[key] &&
    data[key].tripListResponses &&
    data[key].tripListResponses.length
  ) {
    returnVal = data[key].tripListResponses
  }
  return returnVal
}

export const getTripType = details => {
  let type
  if (objectHasKey(details, AIR_TRIP)) {
    type = AIR_TRIP
  } else if (objectHasKey(details, TRAIN_TRIP)) {
    type = TRAIN_TRIP
  } else if (objectHasKey(details, LOCAL_TRIP)) {
    type = LOCAL_TRIP
  } else if (objectHasKey(details, HOTEL_TRIP)) {
    type = HOTEL_TRIP
  }
  return type
}

export const hasValidTripToolAction = label => {
  let returnValue = false
  if (label === CANCEL_TRIP_HEADER || label === CHECK_REFUND_HEADER) {
    returnValue = isCancellable()
  } else if (label === CHANGE_FLIGHT_HEADER) {
    returnValue = isAmendable()
  } else if (label === EMAIL_TRIP_HEADER) {
    returnValue = true
  }
  return returnValue
}

/*
  Util method defined to update the level sent in payload to fetch options
*/
export const updateOptionsLevel = str => {
  let num = 0
  const numChar = parseInt(str.charAt(1), 10)
  if (str && typeof numChar === 'number' && !Number.isNaN(numChar)) {
    num = numChar + 1
  }
  return str.charAt(0) + num
}

export const formatTripName = tripDetails => {
  let tripTitle = tripDetails.tripName;
  
  const language = getCookie('selectedLanguage');
  const isRTL = language === 'ar';
  
  if (tripDetails && tripDetails.tripType === AIR_TRIP) {
    if (tripDetails.tripName !== '--') {
      if (tripDetails.tripName && tripDetails.tripName.indexOf('one-way') > -1) {
        const parts = tripDetails.tripName.split('one-way')[0].trim().split(' - ');
        const origin = parts[0] || '';
        const destination = parts[1] || '';
        
        if (isRTL) {
          tripTitle = `${destination}&larr;${origin}`;
        } else {
          tripTitle = `${origin}&rarr;${destination}`;
        }
        
        tripTitle = htmlDecoder(tripTitle);
      } else if (tripDetails.tripName && tripDetails.tripName.indexOf('multi-city') > -1) {
        tripTitle = tripDetails.tripName;
      } else {
        const parts = tripDetails.tripName.split('return')[0].trim().split(' - ');
        const origin = parts[0] || '';
        const destination = parts[1] || '';
        
        tripTitle = `${origin}&#8644;${destination}`;
        tripTitle = htmlDecoder(tripTitle);
      }
    }
  }
  return tripTitle;
}
const positiveStatusArr = ['upcoming', 'approved', 'payment details confirmed', 'payment complete', 'confirmed', 'refund complete', 'e-ticket sent', 'pnr received', 'booking confirmed', 'refunded', 'rescheduled', 'rescheduled by airline']
export const negativeStatusArr = ['payment failed', 'rejected', 'elapsed', 'discarded', 'no show', 'booking dropped', 'payment unsuccessful', 'cancelled', 'booking failed', 'expired', 'refund failed']
const progressStatusArr = ['on hold', 'open ticket pending', 'processing e-ticket', 'awaiting pnr', 'processing payment', 'initiating refund', 'initiating refund', 'payment initialized', 'payment initiated', 'refund processed', 'processing', 'payment processing']
export const neutralStatusArr = ['refunded', 'completed', 'reserved', 'pnr', 'open ticket completed', 'e-ticket', 'cancelled', 'neutral', 'no payment deducted', 'checking details']

export const statusArr = [
  ...negativeStatusArr,
  ...positiveStatusArr,
  ...progressStatusArr
]
export const disableTrackers = ['confirmed']
export const disableFAQs = ['payment failed', 'booking failed', 'payment initialized', 'cancelled', 'expired']

export const getStatusBgClass = (status = '') => {
  let returnVal = 'neutral-status'
  const newStatus = status || ''
  if (positiveStatusArr.indexOf(newStatus.toLowerCase()) > -1) {
    returnVal = 'green-status'
  } else if (negativeStatusArr.indexOf(newStatus.toLowerCase()) > -1) {
    returnVal = 'red-status'
  } else if (progressStatusArr.indexOf(newStatus.toLowerCase()) > -1) {
    returnVal = 'yellow-status'
  } else if (neutralStatusArr.indexOf(newStatus.toLowerCase()) > -1) {
    returnVal = 'neutral-status'
  }
  return returnVal
}
